const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const FILES_ENDPOINT = process.env.REACT_APP_FILES_ENDPOINT;

export { API_ENDPOINT, FILES_ENDPOINT };
